<ng-container
  *ngIf="{
    containerImages: containerImages$ | async,
  } as content"
>
  <div class="container-product-thumbs">
    @if (content!.containerImages!.length > 4) {
      <p-carousel
        [value]="content.containerImages || []"
        [numVisible]="4"
        [numScroll]="1"
        [circular]="true"
        [autoplayInterval]="false"
        [classList]="'custom-carousel floating-indicator'"
      >
        <ng-template pTemplate="container" let-container>
          <cx-media
            [media]="container.thumbnail"
            (click)="setImage(container)"
            role="none"
            [ngClass]="{ 'is-active': container.thumbnail.src === currentImage.thumbnail.src }"
          />
        </ng-template>

        <ng-template pTemplate="previousicon" let-banner>
          <span class="material-symbols-outlined text-primary"> arrow_back_ios </span>
        </ng-template>

        <ng-template pTemplate="nexticon" let-banner>
          <span class="material-symbols-outlined text-primary m-l-12"> arrow_forward_ios </span>
        </ng-template>
      </p-carousel>
    } @else {
      <ul class="p-carousel-items-container">
        <li class="p-carousel-item" *ngFor="let container of content.containerImages">
          <cx-media
            [media]="container.thumbnail"
            [ngClass]="{ 'is-active': container.thumbnail.src === currentImage.thumbnail.src }"
            (click)="setImage(container)"
          />
        </li>
      </ul>
    }
  </div>
</ng-container>
